export const IRTPC_TYPE_LOSING_REGISTRANT = 'LosingRegistrant'
export const IRTPC_TYPE_GAINING_REGISTRANT = 'GainingRegistrant'
export const IRTPC_TYPE_CHANGED_REGISTRANT = 'ChangedRegistrant'
export const IRTPC_TYPE_VALUES = [IRTPC_TYPE_LOSING_REGISTRANT, IRTPC_TYPE_GAINING_REGISTRANT, IRTPC_TYPE_CHANGED_REGISTRANT]
export const IRTPC_TYPE_DEFAULT_VALUE = IRTPC_TYPE_LOSING_REGISTRANT
